import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export const siteLinks = {
  home: 'https://tusmultas.cl/',
  services: 'https://tusmultas.cl/#servicios',
  quote: 'https://cotizador.tusmultas.cl',
  faq: 'https://tusmultas.cl/#preguntas-frecuentes',
  tracking: 'https://stage-personas.tusmultas.cl/cliente/login',
};

const NAV_ITEMS = [
  { label: 'Servicios', href: 'https://tusmultas.cl/#servicios' },
  { label: 'FAQ', href: 'https://tusmultas.cl/#preguntas-frecuentes' },
  { label: 'Pagar Cotización', to: '/' },
  { label: 'Consultar Trámite', href: 'https://stage-personas.tusmultas.cl/cliente/login' },
  { label: 'Analizamos tu caso', href: 'https://cotizador.tusmultas.cl/analizamos-tu-caso' },
];

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (!isMenuOpen) {
      return;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [isMenuOpen]);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="tm-site-header">
      <div className="tm-main-header">
        <div className="tm-main-header-inner">
          <a href="https://tusmultas.cl/" className="tm-logo">
            <img
              src={`${process.env.PUBLIC_URL}/assets/img/figma/logo-header.png`}
              alt="TusMultas"
              width="170"
              height="40"
              style={{ marginLeft: '-4px' }}
            />
          </a>

          <div
            className={`tm-nav-overlay ${isMenuOpen ? 'tm-nav-overlay-open' : ''}`}
            onClick={closeMenu}
          />

          <nav id="tmNav" className={`tm-nav ${isMenuOpen ? 'tm-nav-open' : ''}`} aria-label="Principal">
            <button type="button" className="tm-nav-close" aria-label="Cerrar menú" onClick={closeMenu}>
              <span className="tm-nav-close__icon" aria-hidden="true">&#10005;</span>
            </button>
            <ul className="tm-menu">
              {NAV_ITEMS.map((item) => (
                <li key={item.label}>
                  {item.to ? (
                    <Link to={item.to} onClick={closeMenu}>
                      {item.label}
                    </Link>
                  ) : (
                    <a href={item.href} onClick={closeMenu}>
                      {item.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </nav>

          <button
            type="button"
            className="tm-burger"
            aria-label={isMenuOpen ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={isMenuOpen}
            aria-controls="tmNav"
            onClick={() => setIsMenuOpen((open) => !open)}
          >
            <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'}`} aria-hidden="true" />
          </button>

          <a href="https://cotizador.tusmultas.cl" className="tm-cta-btn">
            COTIZAR
          </a>
        </div>
      </div>
    </header>
  );
}
